(function () {
  'use strict';

  function initialiseCartForm(form) {
    if (form.hasAttribute('data-cart-ready')) return;
    form.setAttribute('data-cart-ready', '');
    var variantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var button = form.querySelector('button[name="add"]');
    var label = button.querySelector('[data-atc-label]');
    var status = form.querySelector('.mas-home-playful__cart-status');
    var quantityNote = form.querySelector('.mas-home-playful__quantity-note');
    var resetTimer;

    function selectedOption() {
      return variantInput.tagName === 'SELECT' ? variantInput.options[variantInput.selectedIndex] : variantInput;
    }

    function clearStatus() {
      status.hidden = true;
      status.textContent = '';
      status.removeAttribute('data-state');
    }

    function updateVariant() {
      var option = selectedOption();
      if (!option) return;
      var available = option.getAttribute('data-atc-available') === 'true';
      var quantity = Math.max(1, Number(option.getAttribute('data-atc-quantity')) || 1);
      quantityInput.value = quantity;
      quantityInput.min = quantity;
      quantityInput.step = option.getAttribute('data-atc-increment') || '1';
      var maximum = option.getAttribute('data-atc-maximum');
      if (maximum) quantityInput.max = maximum;
      else quantityInput.removeAttribute('max');
      quantityNote.hidden = quantity === 1;
      quantityNote.textContent = quantity > 1 ? 'Adds ' + quantity + ' to your cart' : '';
      button.disabled = !available;
      label.textContent = available ? 'Add to cart' : 'Sold out';

      var price = form.querySelector('hdt-price');
      var priceList = form.querySelector('.hdt-price__list');
      if (price && priceList) {
        var money = price.querySelector('.hdt-money');
        if (money) money.textContent = option.getAttribute('data-atc-price-text');
        if (form.getAttribute('data-price-varies') === 'true' && !price.querySelector('[data-atc-only]')) {
          var prefix = document.createElement('span');
          prefix.setAttribute('data-atc-only', '');
          prefix.textContent = 'Only ';
          price.insertBefore(prefix, money);
        }
        var compare = priceList.querySelector('hdt-compare-at-price');
        if (!compare) {
          compare = document.createElement('hdt-compare-at-price');
          compare.className = 'hdt-compare-at-price';
          var description = document.createElement('span');
          description.className = 'sr-only sr-only--inline';
          description.textContent = 'Regular price ';
          var compareMoney = document.createElement('span');
          compareMoney.className = 'hdt-money';
          compare.append(description, compareMoney);
          priceList.insertBefore(compare, price);
        }
        compare.hidden = Number(option.getAttribute('data-atc-compare-price')) <= Number(option.getAttribute('data-atc-price'));
        compare.querySelector('.hdt-money').textContent = option.getAttribute('data-atc-compare-text') || '';
      }

      var card = form.closest('.mas-home-playful__product');
      var discountBadge = card.querySelector('[data-favourite-discount]');
      if (discountBadge) {
        var comparePrice = Number(option.getAttribute('data-atc-compare-price'));
        var salePrice = Number(option.getAttribute('data-atc-price'));
        var percentage = comparePrice > salePrice && comparePrice > 0 ? Math.round((comparePrice - salePrice) * 100 / comparePrice) : 0;
        discountBadge.hidden = percentage <= 0;
        discountBadge.textContent = percentage + '% OFF';
      }
      var campaign = card.querySelector('[data-card-offer]');
      if (campaign) {
        // Markup is generated only by the theme's mas-sale-badge snippet.
        var offerMarkup = option.getAttribute('data-atc-offer') || '';
        campaign.innerHTML = offerMarkup;
        campaign.hidden = !offerMarkup;
      }
      var saving = card.querySelector('[data-sale-saving]');
      if (saving) {
        saving.hidden = Number(option.getAttribute('data-atc-compare-price')) <= Number(option.getAttribute('data-atc-price'));
        saving.textContent = 'You save ' + (option.getAttribute('data-atc-saving-text') || '');
      }
      card.querySelectorAll('.mas-home-playful__product-image, h3 a').forEach(function (link) {
        var url = new URL(link.href);
        url.searchParams.set('variant', variantInput.value);
        link.href = url.toString();
      });
      clearStatus();
    }

    variantInput.addEventListener('change', function () {
      if (form.dataset.submittingVariant) {
        variantInput.value = form.dataset.submittingVariant;
        return;
      }
      clearTimeout(resetTimer);
      updateVariant();
      document.dispatchEvent(new CustomEvent('currency:update'));
    });

    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      clearTimeout(resetTimer);
      clearStatus();
      form.dataset.submittingVariant = variantInput.value;
      label.textContent = 'Adding…';
    });

    form.addEventListener('variant:add', function () {
      delete form.dataset.submittingVariant;
      label.textContent = 'Added!';
      status.hidden = false;
      status.textContent = 'Added to your cart.';
      status.setAttribute('data-state', 'success');
      resetTimer = setTimeout(function () {
        label.textContent = 'Add to cart';
        clearStatus();
      }, 2500);
    });

    form.addEventListener('cart:add:error', function (event) {
      delete form.dataset.submittingVariant;
      label.textContent = 'Add to cart';
      status.hidden = false;
      status.setAttribute('data-state', 'error');
      status.textContent = typeof event.detail.error === 'string' ? event.detail.error : 'This option could not be added. Please try again.';
    });

    updateVariant();
  }

  function initialiseWithin(scope) {
    scope.querySelectorAll('form[data-mas-home-cart]').forEach(initialiseCartForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseWithin(document); }, { once: true });
  } else {
    initialiseWithin(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialiseWithin(event.target); });
}());
